<!--  -->
<template>
  <div style="text-align:center">
    <img :src="img" alt="">
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      img: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(imgr) {
      this.img = imgr
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
